import { render, staticRenderFns } from "./taskLog.vue?vue&type=template&id=4ba1710d&scoped=true"
import script from "./taskLog.vue?vue&type=script&lang=js"
export * from "./taskLog.vue?vue&type=script&lang=js"
import style0 from "./taskLog.vue?vue&type=style&index=0&id=4ba1710d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1710d",
  null
  
)

export default component.exports